import instance from "../utils/request.js"
import { getRequest } from "../utils/request.js"

/*获取所有客户信息*/
export function GetClient(data = {}){
return instance.request({
        method: "get",
        url: "basicdata/client/",
        params:data
    })
}

/*获取图片客户信息*/
export function GetPictureClient(data = {}){
return instance.request({
        method: "get",
        url: "basicdata/picturecli/",
        params:data
    })
}

/*获取生产订单供应商信息*/
export function GetProductionorderSupplier(data = {}){
return instance.request({
        method: "get",
        url: "basicdata/productionordersupplier/",
        params:data
    })
}

/*获取客户编辑信息*/
export function ClientEditInfo(data = {}){
return instance.request({
        method: "get",
        url: "basicdata/clientedit/",
        params:data
    })
}

/*客户编辑*/
export function ClientEdit(data = {}){
    let params = new URLSearchParams();
    params.append('clientid',data.clientid);
    params.append('clientname',data.clientname);
    params.append('telephone',data.telephone);
     params.append('address',data.address);
     params.append('wechat',data.wechat);
     params.append('suppliersign',data.suppliersign);
     params.append('clientsign',data.clientsign);
     params.append('state',data.state);
     params.append('notes',data.notes);
return instance.request({
        method: "post",
        url: "basicdata/clientedit/",
        data:params
    })
}

/*客户新增*/
export function ClientAdd(data = {}){
    let params = new URLSearchParams();
     params.append('clientname',data.clientname);
     params.append('telephone',data.telephone);
     params.append('address',data.address);
     params.append('wechat',data.wechat);
     params.append('suppliersign',data.suppliersign);
     params.append('clientsign',data.clientsign);
     params.append('state',data.state);
     params.append('notes',data.notes);
return instance.request({
        method: "post",
        url: "basicdata/clientadd/",
        data:params
    })
}

/*客户删除*/
export function ClientDel(data = {}){
    let params = new URLSearchParams();
    params.append('clientid',data.clientid)
return instance.request({
        method: "post",
        url: "basicdata/clientdel/",
        data:params
    })
}